import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';


@Component({
  selector: 'app-custom-autocomplete',
  standalone: true,
  imports: [CommonModule, FormsModule, AutoCompleteModule],
  templateUrl: './custom-autocomplete.component.html',
  styleUrl: './custom-autocomplete.component.css'
})
export class CustomAutocompleteComponent implements OnInit, OnChanges {
  @Input() labelText: string = '';
  @Input() placeholder: string = '';
  @Input() errorMessage: string | null = null;
  @Input() isDisabled: boolean = false;
  @Input() suggestions: any[] = [];
  @Input() selectedItem: any = null;
  @Input() boxHeight: string = '';
  @Output() selectedItemChange = new EventEmitter<any>();
  @Input() labelRenderer: (item: any) => string = (item) => item.code;

  @Input() title: string = '';
  @Input() disabledTitle: string | null = null;

  datalistId = 'datalist-' + Math.random().toString(36).substring(2);
  inputValue: string = '';

  filteredSuggestions: any[] = [];

  ngOnInit() {
    this.filteredSuggestions = [...this.suggestions];
    if (this.selectedItem) {
      this.inputValue = this.labelRenderer(this.selectedItem);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedItem']) {
      const newItem = changes['selectedItem'].currentValue;
      this.inputValue = newItem ? this.labelRenderer(newItem) : '';
    }
  }


  onInputChange(event: any) {
    const value = event.target.value;
    this.inputValue = value;

    const query = value.toLowerCase();
    this.filteredSuggestions = this.suggestions.filter((item) =>
      this.labelRenderer(item).toLowerCase().includes(query)
    );

    const matched = this.suggestions.find(
      (item) => this.labelRenderer(item) === value
    );
    if (matched) {
      this.selectedItem = matched;
      this.selectedItemChange.emit(matched);
    } else {
      this.selectedItem = null;
      this.selectedItemChange.emit(null);
    }
  }

  get getTitle(): string {
    if (this.isDisabled && this.disabledTitle != null) {
      return this.disabledTitle;
    }

    return this.title;
  }
}
